import script from "./OrderBookContract.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderBookContract.vue?vue&type=script&setup=true&lang=ts"

import "./OrderBookContract.vue?vue&type=style&index=0&id=0de9870c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de9870c"]])

export default __exports__